/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Ship_Ammo_SpreadInputs */

const ja_calendar_ship_ammo_spread = /** @type {(inputs: Calendar_Ship_Ammo_SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スプレッド`)
};

const en_calendar_ship_ammo_spread = /** @type {(inputs: Calendar_Ship_Ammo_SpreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPREAD`)
};

/**
* | output |
* | --- |
* | "SPREAD" |
*
* @param {Calendar_Ship_Ammo_SpreadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_ship_ammo_spread = /** @type {((inputs?: Calendar_Ship_Ammo_SpreadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Ship_Ammo_SpreadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_ship_ammo_spread(inputs)
	return en_calendar_ship_ammo_spread(inputs)
});